import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { EditVideoAttributeInteractionActions } from './types';

export function editVideoAttributeInteractionActionEvent({
  action,
}: {
  action: EditVideoAttributeInteractionActions;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.EDIT_VIDEO_ATTRIBUTES_CHANGED_ACTIONS,
  };

  pushToDataLayer({
    ...eventAttributes,
    action,
  });
}
